// 개인정보처리방침. 수집항목/목적/보유기간/위탁/정보주체 권리/보호책임자를 명시한다.
// 위탁: 포트원+KPN(결제), 네이버클라우드 SENS(SMS), Cloudflare(인프라), 카카오/네이버/구글(소셜로그인).

import LegalPageShell, { LegalSection } from "@/shared/LegalPageShell.tsx";
import { BUSINESS_INFO } from "@/shared/businessInfo.ts";

// 개인정보처리방침 본문. 전체 페이지와 가입 동의 모달에서 공용으로 쓴다.
export function PrivacyContent() {
  return (
    <>
      <p>
        {BUSINESS_INFO.name}(이하 "매장")은 「개인정보 보호법」 등 관련 법령을 준수하며, 이용자의 개인정보를
        다음과 같이 처리합니다.
      </p>

      <LegalSection heading="1. 수집하는 개인정보 항목">
        <p>- 회원: 이름, 휴대폰번호, 소셜 로그인 식별자(소셜 가입 시)</p>
        <p>- 주문/배송: 수령인 이름, 연락처, 배송지 주소</p>
        <p>- 거래: 주문·결제 내역, 적립금·쿠폰 이용 내역</p>
        <p>- 결제: 카드 결제 시 결제대행사(포트원/KPN)를 통해 처리되며, 카드번호 등 카드정보는 매장 서버에 저장하지 않습니다.</p>
      </LegalSection>

      <LegalSection heading="2. 개인정보의 이용 목적">
        <p>회원 식별 및 관리, 주문·결제·배송, 고객 문의 응대, 적립금·쿠폰 운영, 관련 법령상 의무 이행.</p>
      </LegalSection>

      <LegalSection heading="3. 보유 및 이용 기간">
        <p>회원 정보는 회원 탈퇴 시까지 보유하며, 관련 법령에 따라 다음 기간 동안 보존합니다.</p>
        <p>- 계약 또는 청약철회 등에 관한 기록: 5년</p>
        <p>- 대금결제 및 재화 등의 공급에 관한 기록: 5년</p>
        <p>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</p>
        <p>- 표시·광고에 관한 기록: 6개월</p>
      </LegalSection>

      <LegalSection heading="4. 개인정보의 제3자 제공 및 처리위탁">
        <p>매장은 원활한 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁합니다.</p>
        <p>- (주)포트원, 한국결제네트웍스(KPN): 결제 처리 및 카드 매입·정산</p>
        <p>- 네이버클라우드(주): 인증/알림 문자(SMS) 발송</p>
        <p>- Cloudflare, Inc.: 서버·인프라 호스팅 및 데이터 보관</p>
        <p>- 카카오, 네이버, 구글: 소셜 로그인 인증(이용자가 소셜 로그인을 선택한 경우)</p>
      </LegalSection>

      <LegalSection heading="5. 정보주체의 권리">
        <p>
          이용자는 자신의 개인정보에 대한 열람·정정·삭제·처리정지를 요청할 수 있으며, 회원 탈퇴를 통해
          개인정보 수집·이용 동의를 철회할 수 있습니다.
        </p>
      </LegalSection>

      <LegalSection heading="6. 개인정보의 파기">
        <p>보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.</p>
      </LegalSection>

      <LegalSection heading="7. 개인정보 보호책임자">
        <p>- 책임자: {BUSINESS_INFO.privacyOfficer.name}</p>
        <p>- 연락처: {BUSINESS_INFO.privacyOfficer.contact}</p>
      </LegalSection>

      <LegalSection heading="8. 방침의 변경">
        <p>본 방침은 법령·서비스 변경에 따라 개정될 수 있으며, 개정 시 앱을 통해 공지합니다.</p>
      </LegalSection>
    </>
  );
}

// 개인정보처리방침 페이지(셸 + 본문).
export default function PrivacyPage() {
  return (
    <LegalPageShell title="개인정보처리방침" updatedAt="2026-06-22">
      <PrivacyContent />
    </LegalPageShell>
  );
}
